import { useQueryClient } from '@tanstack/react-query'

export function useInvalidateQueries() {
  const queryClient = useQueryClient()

  return function invalidateQueries(queryKeys: unknown[]) {
    const invalidatePromises = queryKeys.map((queryKey) =>
      queryClient.invalidateQueries({ queryKey }),
    )

    return Promise.all(invalidatePromises)
  }
}
